var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSiHomeLine = function SvgSiHomeLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-hidden": "true",
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium mui-1ym952v",
    focusable: "false",
    style: {
      fill: "none"
    },
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M15.5 18.333h-11a2 2 0 0 1-2-2.01v-9.38c0-.318.15-.611.4-.804l6.483-4.271a.996.996 0 0 1 1.2 0L17.1 6.139c.25.193.4.486.4.804v9.38a2 2 0 0 1-2 2.01Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M8.167 10h3.666c.367 0 .667.3.667.667v7.666h-5v-7.666c0-.367.3-.667.667-.667Z"
  })));
};
export default SvgSiHomeLine;